/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { CategoryMetaTable } from "./CategoryMetaTable";
import { EnvService } from "namirasoft-core";
import { InstanceMetaTable } from "./InstanceMetaTable";
import { NSBaseMetaDatabase } from "namirasoft-site";
import { NamirasoftAPIProductServer } from "../NamirasoftAPIProductServer";
import { OwnerMetaTable } from "./OwnerMetaTable";
import { ProductMetaTable } from "./ProductMetaTable";
import { StoreMetaTable } from "./StoreMetaTable";

export class NamirasoftAPIProductMetaDatabase extends NSBaseMetaDatabase<NamirasoftAPIProductServer>
{
    private onError?: (error: Error) => void;
    public override tables: {
        category: CategoryMetaTable,
        instance: InstanceMetaTable,
        owner: OwnerMetaTable,
        product: ProductMetaTable,
        store: StoreMetaTable,
    };
    constructor(onError?: (error: Error) => void)
    {
        super({ id: "prd-62ad582bb6034386", name: "Namirasoft API Product", headline: "", description: "", logo: "https://static.namirasoft.com/image/namirasoft/product/logo/base.png", link: "" });
        this.onError = onError;
        this.tables = {
            category: new CategoryMetaTable(this),
            instance: new InstanceMetaTable(this),
            owner: new OwnerMetaTable(this),
            product: new ProductMetaTable(this),
            store: new StoreMetaTable(this),
        };
    }
    override getServer(): NamirasoftAPIProductServer
    {
        if (!this.onError)
            throw new Error("Arguments of NamirasoftAPIProductMetaDatabase (onError) are required for server operations.")
        let NAME = NSBaseMetaDatabase.getServerBaseURL(this.product.name);
        let BASE_URL = new EnvService(NAME, true).getString();
        return new NamirasoftAPIProductServer(BASE_URL, this.onError);
    }
};